import Recipe from 'components/recipe/Recipe';
import Layout from 'containers/Layout';
import contentful from 'lib/contentful';
import { RecipeQueryResponse } from 'lib/contentful/data/recipe';
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';
import { ProductIncludes, REVALIDATION_TIME } from 'lib/constants';

const Page: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({ data }) => {
  const { recipe, siteSettings, preview } = data;

  return (
    <Layout
      preview={preview}
      siteSettings={siteSettings}
      seo={{
        title: recipe.metaTitle || recipe.title,
        description: recipe.metaDescription || recipe.description,
        openGraphImageUrl: recipe.image?.url,
      }}
    >
      <Recipe {...data.recipe} />
    </Layout>
  );
};

export const getStaticPaths: GetStaticPaths = async (context) => {
  const pages = await contentful.recipes.allRecipesPath({});

  const paths: Array<{ params: { slug: string } }> = pages.map((x) => {
    return {
      params: {
        slug: x.slug,
      },
    };
  });

  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<{ data: RecipeQueryResponse }> = async ({
  preview,
  params,
}) => {
  const recipeQueryResponse = await contentful.recipes.getRecipe({
    slug: params?.slug as string,
    preview,
    include: [ProductIncludes.moreRecipes, ProductIncludes.relatedProducts],
  });

  if (!recipeQueryResponse?.recipe) {
    return {
      notFound: true,
    };
  }

  return {
    revalidate: REVALIDATION_TIME.SHORT,
    props: {
      data: recipeQueryResponse,
    },
  };
};

export default Page;
